/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import $ from 'jquery';

export default function (selector = '.js-init-ellipsis') {
  const $init = $(selector + ':not(.js-done)').addClass('js-done');

  $init.on('click', '.js-toggle-ellipsis', function (ev) {
    ev.preventDefault();
    $(this).parent().toggleClass('is-expanded');
  });
}
